import React, {useState} from "react";
import clsx from "clsx";
import { Button, Link, Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem, Container, IconButton, useTheme, Drawer, AppBar, Toolbar, CssBaseline, Typography, Divider
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Project2_TechnicalSummary from "../images/Project2_TechnicalSummary.pdf";
import CountryRoad from "../images/architecture.jpg";
import Image from "material-ui-image";


//Icons
import AssessmentIcon from "@material-ui/icons/Assessment";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MenuIcon from "@material-ui/icons/Menu";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PublicIcon from "@material-ui/icons/Public";

//Components
import Map2 from "../components/Map2Components/Map2";
import MapModal from "../components/MapModal";
import CopyUrlBtn from "../components/CopyUrlBtn";
import Map2Plots from "../components/Map2Components/Map2Plots";
import IntroModal from "../components/IntroModal";

const drawerWidth = 550;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // minHeight: "7.1vh",
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  toolbar: {
    minHeight: "48px"
  },
  title: {
    flexGrow: 1,
    fontSize: "23px",
    [theme.breakpoints.down("md")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    minHeight: "92.9vh",
    // 1920px
    [theme.breakpoints.down("xl")]: {
      minHeight: "99vh",
    },
    // 1280px
    [theme.breakpoints.down("lg")]: {
      minHeight: "92.9vh",
    },
    // 960px
    [theme.breakpoints.down("md")]: {
      minHeight: "92.9vh",
    },
    // 600px
    [theme.breakpoints.down("sm")]: {
      minHeight: "92.9vh",
    },
    // 0px
    [theme.breakpoints.down("xs")]: {
      minHeight: "93.8vh",
    },
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#CED8D7",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  beta: {
    color: "#DEF000",
    align: "left",
  },
  assessmentIcon: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

export default function PersistentDrawerRight() {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [graphData, setGraphData] = useState(null);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [open2, setOpen2] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen2((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen2(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen2(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open2);
  React.useEffect(() => {
    if (prevOpen.current === true && open2 === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open2;
  }, [open2]);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <div>
            <Button
              ref={anchorRef}
              aria-controls={open2 ? "menu-list-grow" : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              color="inherit"
              edge="start"
              className={classes.menuButton}
              aria-label="open drawer"
            >
              <MenuIcon />
            </Button>
            <Popper
              open={open2}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper
                    style={{
                      border: "7px solid #CED8D7",
                    }}
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        autoFocusItem={open}
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                        className={classes.MenuList}
                      >
                        <MenuItem onClick={handleClose}>
                          <Link color="inherit" href="/">
                            <ExitToAppIcon
                              style={{ color: "rgb(246, 122, 55)" }}
                            />
                            &nbsp; Connectivity on Agricultural Lands
                          </Link>
                        </MenuItem>
                        <MenuItem onClick={handleClose} disabled>
                          <Link color="inherit" href="/project1">
                            <ExitToAppIcon
                              style={{ color: "rgb(246, 122, 55)" }}
                            />
                            &nbsp; Anthropogenic Impacts
                          </Link>
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                          <Link color="inherit" href="/project3">
                            <ExitToAppIcon
                              style={{ color: "rgb(246, 122, 55)" }}
                            />
                            &nbsp; Monitoring Forest Change
                          </Link>
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                          <Link
                            color="inherit"
                            href="https://analytics-lab.org/ecosystemmonitoring/"
                          >
                            <PublicIcon
                              style={{ color: "rgb(246, 122, 55)" }}
                            />
                            &nbsp; Analytics Lab + AI for Earth
                          </Link>
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>

          <div style={{marginLeft: "15px"}}>        
          <CopyUrlBtn />
          </div>  

          <MapModal
            align="center"
            ModalTitle={"About This Map"}
            ModalBody={
              <>
                <p style={{ fontSize: "1rem" }}>
                  Mediating human development and land-use related impacts is a
                  crucial factor in conserving wild and endangered species of
                  plants and animals worldwide. A primary and essential step in
                  doing so is assessing the extent and degree of anthropogenic
                  impacts and how they are changing over time. While data on
                  such impacts are available from a variety of disparate
                  sources, they are rarely available in a consistent and current
                  representation over large areas. To remedy this, Conservation
                  Science Partners in partnership with the Microsoft AI for
                  Earth program are using cutting edge deep-learning methods and
                  an extensive library of training data to assess anthropogenic
                  impacts across the conterminous US and across decadal scales.
                  The draft results shown here quantify the degree of urban
                  development and will be refined and expanded to include other
                  types of development, larger areas, and longer time periods.
                </p>
                <p style={{ fontSize: "1rem" }}>
                  Download the technical summary and methods
                  <a
                    href={Project2_TechnicalSummary}
                    download="Assessing_Anthropogenic_Impacts"
                  >
                    {" "}
                    here.
                  </a>
                </p>
                <Image src={CountryRoad} cover={true} disableTransition style={{padding: "45px"}}/>
              </>
            }
            // modalImage={CountryRoad}
            style={{ paddingRight: "3px" }}
          ></MapModal>

          <Typography variant="h6" align="center" className={classes.title}>
            Assessing Anthropogenic Impacts on Terrestrial Landscapes Over Time
          </Typography>

          <IntroModal
          align="center"
          ModalTitle={"Welcome"}
          ModalBody={
            <>
              <p style={{ fontSize: "1rem" }}>
              Mediating human development and land-use related impacts is a crucial factor in conserving wild and endangered species of plants and animals worldwide. A primary and essential step in doing so is assessing the extent and degree of anthropogenic impacts and how they are changing over time. While data on such impacts are available from a variety of sources, they rarely exist in a current and unified format over large areas. To remedy this, Conservation Science Partners in partnership with the Microsoft AI for Earth program are using cutting edge deep-learning methods and an extensive library of training data to assess anthropogenic impacts across the conterminous US and across decadal scales. The results shown here quantify the degree of agricultural, transportation, and urban impact in the conterminous U.S.
              </p>
              <p style={{ fontSize: "1rem" }}>
              Download the technical summary and methods <a href="https://cspbeta.z22.web.core.windows.net/static/media/Project2_TechnicalSummary.0e592ac1.pdf">here</a>.
              </p>
          </>
          }>
          </IntroModal>

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerOpen}
            className={clsx(open && classes.hide)}
          >
            <AssessmentIcon className={classes.assessmentIcon} fontSize="large" />
          </IconButton>
        </Toolbar>
      </AppBar>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.drawerHeader} />
        <Map2 style={{ flexGrow: 1 }} graphData={graphData} setGraphData={setGraphData} setOpen={setOpen}/>
      </main>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div
          className={classes.drawerHeader}
          style={{ backgroundColor: "#ffffff" }}
        >
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <>
                <ChevronRightIcon />
              </>
            )}
          </IconButton>
          <Container style={{ backgroundColor: "#ffffff" }}>
            <Typography align="center" variant="h5">
              Graphs
            </Typography>
          </Container>
        </div>
        <Divider />
        <div>
          <Map2Plots graphData={graphData}/>
        </div>
      </Drawer>
    </div>
  );
}
